<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <header-template>
        <template #filterByStatus>
          <to-trinh-qua-han-state-filter
            ref="headerFilter"
            :state="state"
            :title="'Tờ trình quá hạn cho ý kiến'"
            :countOptions="countOptions"
            @stateChanged="stateChanged"
          />
        </template>
      </header-template>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top margin-right-10 txt-center custom-label__input fix-width__large"
                    >
                      <span class="label-input width__auto">Ngày chuyển: </span>
                      <el-date-picker
                        v-model="sendTimeRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="filterBySendTime"
                      >
                      </el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <vb-den-to-trinh-qua-han-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </sub-header>
          </template>

          <template #body>
            <transition name="fade-in">
              <vb-den-table-template
                :order="order"
                :sort="sort"
                :incomingDocs="incomingDocs"
                @infiniteHandler="({ state }) => infiniteHandler(state)"
                @doSort="({ sort }) => doSort(sort)"
                @viewDetail="({ item }) => viewDetail(item)"
                ref="vbDenTableRef"
              >
                <template slot="headerRightSection">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                  <!--                  <div-->
                  <!--                    class="theTitle theTitle__lv2 flex-row flex__left padding-left-10"-->
                  <!--                    @click="doSort('senderName')"-->
                  <!--                  >-->
                  <!--                    Người chuyển-->
                  <!--                    <sort-caret-->
                  <!--                      :order="order"-->
                  <!--                      :sort="sort"-->
                  <!--                      :field="'senderName'"-->
                  <!--                    />-->
                  <!--                  </div>-->
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('sendTime')"
                  >
                    Thời gian chuyển
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'sendTime'"
                    />
                  </div>
                  <!--                  <div-->
                  <!--                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"-->
                  <!--                    @click="doSort('deadlineDate')"-->
                  <!--                  >-->
                  <!--                    Hạn xử lý-->
                  <!--                    <sort-caret-->
                  <!--                      :order="order"-->
                  <!--                      :sort="sort"-->
                  <!--                      :field="'deadlineDate'"-->
                  <!--                    />-->
                  <!--                  </div>-->
                </template>
                <template slot="rowRightSection" slot-scope="{ item }">
                  <div
                    class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                  >
                    <div class="flex-row flex__right txt-right">
                      <i class="cellIcon color__silver fas fa-clock"></i>
                      {{
                        item.docDate
                          | dateFormatter({
                            nullValue: "-",
                            dateFormat: "DD/MM/YYYY"
                          })
                      }}
                    </div>
                  </div>
                  <!--                  <div-->
                  <!--                    class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"-->
                  <!--                  >-->
                  <!--                    <div class="flex-row flex__left">-->
                  <!--                      <display-people :name="item.senderName"/>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div
                    class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                  >
                    <quahan-time :time="item.sendTime"></quahan-time>
                  </div>
                  <!--                  <div-->
                  <!--                    class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"-->
                  <!--                  >-->
                  <!--                    <quahan-time :time="item.deadlineDate"></quahan-time>-->
                  <!--                  </div>-->
                </template>
              </vb-den-table-template>
            </transition>
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>
<script>
import SubHeader from "../../../components/main/sub-header";
import dateUtils from "../../../dateUtils";
import h from "../../../services/h";
import { EventBus } from "../../../event-bus";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import InfiniteLoading from "vue-infinite-loading";
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import vbIncomingDocUserViewService from "../../../services/vbIncomingDocUserViewService";
// import DisplayPeople from "../common/displayPeople";
import listTemplate from "../../common/list";
import headerTemplate from "../../../components/header/main-header.vue";
import searchTemplate from "../../common/search";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SortCaret from "../../doc-out/SortCaret";
import ToTrinhQuaHanStateFilter from "./to-trinh-qua-han-state-filter";
import VbDenTableTemplate from "../vb-den-table-template";
import VbProcessTypeTag from "../vb-process-type-tag";
import utils from "../../../services/utils";
import VbdenAdvanceSearchDialog from "../components/vbden-advance-search-dialog";
import FilterByStatusHeader from "../../doc-out/components/filter-by-status-header";
import QuahanTime from "../../doc-out/quahan-time";
import CxlVbdenDialog from "../components/cxl-vbden-dialog";
import VbDenToTrinhQuaHanAdvanceSearchDialog from "./vb-den-to-trinh-qua-han-advance-search-dialog";

export default {
  name: "vb-den-to-trinh-qua-han-index",
  components: {
    VbDenToTrinhQuaHanAdvanceSearchDialog,
    SubHeader,
    SortCaret,
    // DisplayPeople,
    VbDenTableTemplate,
    VbProcessTypeTag,
    ToTrinhQuaHanStateFilter,
    FilterByStatusHeader,
    VbdenAdvanceSearchDialog,
    CxlVbdenDialog,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    QuahanTime
  },

  filters: { dateFormatter, buildShortNameFilter },

  data() {
    return {
      keyword: null,
      dateQuickFilterOption: null,
      order: null,
      sort: null,
      page: 0,
      incomingDocs: [],
      state: null,
      sendTimeRange: null,
      advanceSearchForm: {
        fromDocDate: null,
        toDocDate: null,
        fromSendTime: null,
        toSendTime: null,
        docCode: null,
        quote: null,
        fileContent: null
      },
      // ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      // INCOMING_PROCESS_STATUS: constants.INCOMING_PROCESS_STATUS,
      // INCOMING_DOC_STATUS: constants.INCOMING_DOC_STATUS,
      // VB_DOC_USER: constants.VB_DOC_USER,
      eventBusForMasterHandler: null,
      countOptions: null,

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false
    };
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      if (newValue) this.isEnableAdvanceSearchDialog = newValue;
    }
  },

  created() {
    this.initDateQuickFilterOption();
    this.initQuery();
    this.registerEventBusForMaster();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  methods: {

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = utils.getDefaultDateQuickFilterOption();
    },

    advanceSearch({ advanceSearchForm }) {
      this.advanceSearchForm = advanceSearchForm;
      this.keyword = null;
      this.initSendTimeRange(
        this.advanceSearchForm.fromSendTime,
        this.advanceSearchForm.toSendTime
      );
      this.doSearch();
    },

    unregisterEventBusForMaster() {
      EventBus.$off(this.$route.name, this.eventBusForMasterHandler);
    },

    registerEventBusForMaster() {
      // console.log(this.$route.name);
      EventBus.$on(
        this.$route.name,
        (this.eventBusForMasterHandler = () => {
          // console.log("registerEventBusForMaster");
          this.doSearch();
        })
      );
    },

    buildRouterQuery() {
      return {
        sort: this.sort,
        order: this.order,
        keyword: this.keyword,
        state: this.state,
        fileContent: this.fileContent,
        fromSendTime: this.advanceSearchForm.fromSendTime,
        toSendTime: this.advanceSearchForm.toSendTime,
        fromDocDate: this.advanceSearchForm.fromDocDate,
        toDocDate: this.advanceSearchForm.toDocDate,
        docCode: this.advanceSearchForm.docCode,
        quote: this.advanceSearchForm.quote
      };
    },

    doSearch() {
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildRouterQuery()
      });
      this.incomingDocs = [];
      this.page = 0;
      this.$nextTick(
        () => this.$refs.vbDenTableRef && this.$refs.vbDenTableRef.doSearch()
      );
    },

    convertToSubmitForm(state) {
      let toTrinhQuaHan = constants.TRUE;
      let isCommented = null;
      let status = [];

      switch (state) {
        case constants.TO_TRINH_QUA_HAN.STATE.ALL:
          break;
        case constants.TO_TRINH_QUA_HAN.STATE.CHUA_XU_LY:
          isCommented = constants.FALSE;
          status = [constants.INCOMING_PROCESS_STATUS.CHO_XU_LY];
          break;
        case constants.TO_TRINH_QUA_HAN.STATE.DA_XU_LY:
          status = [constants.INCOMING_PROCESS_STATUS.DA_XU_LY];
          break;
        case constants.TO_TRINH_QUA_HAN.STATE.DA_BINH_LUAN:
          isCommented = constants.TRUE;
          break;
      }

      return {
        fromSendTime: this.advanceSearchForm.fromSendTime,
        toSendTime: this.advanceSearchForm.toSendTime,
        fromDocDate: this.advanceSearchForm.fromDocDate,
        toDocDate: this.advanceSearchForm.toDocDate,
        keyword: this.advanceSearchForm.keyword,
        docCode: this.advanceSearchForm.docCode,
        quote: this.advanceSearchForm.quote,
        fileContent: this.advanceSearchForm.fileContent,
        toTrinhQuaHan: toTrinhQuaHan,
        isCommented: isCommented,
        status: status
      };
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      let advanceSearchForm = this.convertToSubmitForm(this.state);
      // console.log(JSON.stringify(advanceSearchForm));
      return vbIncomingDocUserViewService
        .findAllToTrinhQuaHan(advanceSearchForm, pageable)
        .then(response => {
          let items = response.data;
          items && this.incomingDocs.push(...items);
          return items;
        });
    },

    count() {
      return Promise.all(
        h.collect(
          [
            constants.TO_TRINH_QUA_HAN.STATE.ALL,
            constants.TO_TRINH_QUA_HAN.STATE.DA_BINH_LUAN,
            constants.TO_TRINH_QUA_HAN.STATE.DA_XU_LY,
            constants.TO_TRINH_QUA_HAN.STATE.CHUA_XU_LY
          ],
          state => {
            let advanceSearchForm = this.convertToSubmitForm(state);
            return vbIncomingDocUserViewService
              .findAllToTrinhQuaHanCount(advanceSearchForm)
              .then(response => {
                return {
                  value: state,
                  count: response.data
                };
              });
          }
        )
      ).then(countOptions => {
        this.countOptions = countOptions;
      });
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
      this.count();
    },

    filterBySendTime() {
      utils.timeRangeChanged(this.sendTimeRange, (fromSendTime, toSendTime) => {
        this.advanceSearchForm.fromSendTime = fromSendTime;
        this.advanceSearchForm.toSendTime = toSendTime;
      });
      this.doSearch();
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.fromDocDate = null;
      this.advanceSearchForm.toDocDate = null;
      this.advanceSearchForm.docCode = null;
      this.advanceSearchForm.quote = null;
      this.advanceSearchForm.fileContent = null;
      this.doSearch();
    },

    initQuery() {
      // console.log("initQuery");
      let query = this.$route.query;
      this.sort = utils.getParamFromQuery(query, "sort") || "sendTime";
      this.order = utils.getParamFromQuery(query, "order") || "desc";
      this.keyword = utils.getParamFromQuery(query, "keyword");
      this.state =
        utils.getParamFromQuery(query, "state") ||
        constants.TO_TRINH_QUA_HAN.STATE.ALL;
      this.advanceSearchForm.fileContent = utils.getParamFromQuery(
        query,
        "fileContent"
      );
      let fromSendTime = utils.getIntParamsFromQuery(query, "fromSendTime");
      let toSendTime = utils.getIntParamsFromQuery(query, "toSendTime");
      this.initSendTimeRange(fromSendTime, toSendTime);
      this.advanceSearchForm.fromDocDate = utils.getIntParamsFromQuery(
        query,
        "fromDocDate"
      );
      this.advanceSearchForm.toDocDate = utils.getIntParamsFromQuery(
        query,
        "toDocDate"
      );
      this.advanceSearchForm.docCode = utils.getParamFromQuery(
        query,
        "docCode"
      );
      this.advanceSearchForm.quote = utils.getParamFromQuery(query, "quote");
    },

    initSendTimeRange(fromSendTime, toSendTime) {
      let sendTimeRange = null;
      if (fromSendTime || toSendTime) {
        sendTimeRange = [new Date(fromSendTime), new Date(toSendTime)];
      } else {
        sendTimeRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
      }
      utils.timeRangeChanged(
        (this.sendTimeRange = sendTimeRange),
        (fromSendTime_, toSendTime_) => {
          this.advanceSearchForm.fromSendTime = fromSendTime_;
          this.advanceSearchForm.toSendTime = toSendTime_;
        }
      );
    },

    stateChanged({ state }) {
      this.state = state;
      this.doSearch();
    },

    viewDetail(item) {
      let query = utils.merge(this.$route.query, {
        vbDocProcessId: item.vbDocUserVbDocProcessId
      });
      let params = utils.merge(this.$route.params, {
        id: item.vbIncomingDocUserViewKey.id
      });
      this.$router.push({
        name: "toTrinhQuaHanDetail",
        params: params,
        query: query
      });
    }
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/to-trinh-qua-han/vb-den-to-trinh-qua-han-index.vue